import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, Users, TrendingUp, FileStack } from "lucide-react";
import SEO from "@/components/app/SEO";

export default function BrokerLandingPage() {
  return (
    <div>
      <SEO
        title="Espace courtiers et cabinets"
        description="Résiliation Express pour courtiers : gestion en masse des résiliations, mandats numériques, tarifs dégressifs, portefeuille PayPal, statistiques temps réel."
        canonical="/courtiers"
      />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-3">Espace courtiers</p>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
              Gérez les résiliations
              <br />
              de vos clients à grande échelle.
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Import CSV, mandats numériques, envois en masse, suivi centralisé, statistiques détaillées : tout ce qu'il faut pour industrialiser votre activité.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild size="lg" className="bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="broker-signup-btn">
                <Link to="/inscription">Créer mon compte courtier</Link>
              </Button>
              <Button asChild variant="outline" size="lg" data-testid="broker-contact-btn">
                <Link to="/contact">Nous contacter</Link>
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: Users, k: "Clients", v: "Gestion illimitée" },
              { icon: FileStack, k: "Dossiers", v: "Traitement en masse" },
              { icon: TrendingUp, k: "Stats", v: "Temps réel" },
              { icon: Check, k: "Mandats", v: "Signature numérique" },
            ].map((s) => (
              <div key={s.k} className="card-elevated p-6">
                <s.icon className="h-6 w-6 mb-3 text-primary" />
                <div className="text-sm text-muted-foreground">{s.k}</div>
                <div className="font-semibold">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-secondary/40 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold tracking-tight mb-10 max-w-xl">Toutes les fonctionnalités dont vous avez besoin.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              ["Gestion des collaborateurs", "Rôles, permissions granulaires, portefeuille de crédits pour vos équipes."],
              ["Import CSV/Excel", "Chargez vos clients et dossiers en masse. Générez des courriers par lot."],
              ["Mandats numériques", "Faites signer vos clients à distance, conservez les mandats en coffre-fort."],
              ["Espace client dédié", "Invitez vos clients à compléter leurs infos, justificatifs et signature."],
              ["Statistiques", "Dashboards détaillés : dossiers, chiffre d'affaires, délais moyens."],
              ["Portefeuille PayPal", "Rechargez votre wallet via PayPal, dépensez en un clic sur vos envois."],
            ].map(([t, d]) => (
              <div key={t} className="card-elevated p-6">
                <div className="font-semibold mb-2">{t}</div>
                <div className="text-sm text-muted-foreground">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
